import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Component } from 'react';
import { CSearchSelectSort } from '@/components/modules/pages/consultantSearch/Form/CSearchSelectSort';
import { WithUnitText } from '@/components/ui/Typography/Body/WithUnitText';
import { SEMINAR_LIST_FILTER_TYPES } from '../../../../define/consts/seminar/seminar_list';
import { propArrayShape, propArrayStr, propBool, propFunc, propNumber, propStr, } from '../../../../helpers/custom-prop-types';
import TypeFilter from '../../../Seminar/List/Filter/TypeFilter';
import ConsultantSearchSlideChangeButton from './ConsultantSearchSlideChangeButton';
class ConsultantSearchSelect extends Component {
    constructor(props) {
        super(props);
        this.getState = (props) => {
            const { options, order } = props;
            const firstOrder = options[0];
            return {
                order: options.find((option) => option.id === order) || firstOrder,
            };
        };
        this.state = Object.assign({}, this.getState(props));
    }
    shouldComponentUpdate(nextProps) {
        const { options, order } = this.props;
        if (options !== nextProps.options || order !== nextProps.order) {
            this.setState(this.getState(nextProps));
            return false;
        }
        return true;
    }
    render() {
        const { hasSlideRole, isDisabled, isSeminar, isShowPsSlide, isSlide, name, onChange, onChangePsSlideSearchType, onChangeSeminarTypes, onChangeSlideSearchType, onClickDisabledSort, options, psSlideSearchType, seminarTypes, slideSearchType, total, } = this.props;
        const { order } = this.state;
        return (_jsxs("div", Object.assign({ className: 'search_list_block_order' }, { children: [_jsx("div", Object.assign({ className: 'search_select_block_count' }, { children: total > 0 && (_jsx(WithUnitText, { count: total, mainText: total, size: 'xxs', unitText: '件を表示中' })) })), _jsx(CSearchSelectSort, { className: clsx('search_select_block', isDisabled && 'locked'), disabled: isDisabled, name: name, onChange: onChange, onClickDisabled: onClickDisabledSort, options: options, value: order.value }), isSeminar && (_jsx("div", Object.assign({ className: 'search_list_block_slide_change_row seminar_list_container' }, { children: _jsx(TypeFilter, { className: 'is-consultantSearch', filters: SEMINAR_LIST_FILTER_TYPES, onChange: onChangeSeminarTypes, types: seminarTypes }) }))), isSlide && hasSlideRole && (_jsx(ConsultantSearchSlideChangeButton, { onChangeSlideSearchType: onChangeSlideSearchType, slideSearchType: slideSearchType })), isShowPsSlide && (_jsx(ConsultantSearchSlideChangeButton, { onChangeSlideSearchType: onChangePsSlideSearchType, slideSearchType: psSlideSearchType }))] })));
    }
}
ConsultantSearchSelect.propTypes = {
    hasSlideRole: propBool().isRequired,
    isDisabled: propBool().isRequired,
    isSeminar: propBool().isRequired,
    isShowPsSlide: propBool().isRequired,
    isSlide: propBool().isRequired,
    name: propStr().isRequired,
    onChange: propFunc().isRequired,
    onChangePsSlideSearchType: propFunc().isRequired,
    onChangeSeminarTypes: propFunc().isRequired,
    onChangeSlideSearchType: propFunc().isRequired,
    onClickDisabledSort: propFunc().isRequired,
    options: propArrayShape().isRequired,
    order: propStr().isRequired,
    psSlideSearchType: propStr().isRequired,
    seminarTypes: propArrayStr().isRequired,
    slideSearchType: propStr().isRequired,
    total: propNumber().isRequired,
};
export default ConsultantSearchSelect;
